import { render, staticRenderFns } from "./pageModal.vue?vue&type=template&id=115a4b2a&scoped=true&"
import script from "./pageModal.vue?vue&type=script&lang=js&"
export * from "./pageModal.vue?vue&type=script&lang=js&"
import style0 from "./pageModal.vue?vue&type=style&index=0&id=115a4b2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115a4b2a",
  null
  
)

export default component.exports